import envs from "config/envs";

export const AchievementsOurCards = [
  {
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/card_premio_abt.webp`,
    imageFallback: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/card_premio_abt.webp`,
    title: "XXV Prêmio ABT",
    paragraph:
      "Bronze na categoria “Operações de Atendimento (Contratante) | Seguros”.",
    Backgroundcolor: "#008C84",
  },
  {
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/card_international_business_awards.webp`,
    imageFallback: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/card_international_business_awards.webp`,
    title: "International Business Awards",
    paragraph: "Bronze na categoria “Time de Experiência do Cliente do Ano”.",
    Backgroundcolor: "#D70064",
  },
  {
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/card_client_sa.webp`,
    imageFallback: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/card_client_sa.webp`,
    title: "ClienteSA",
    paragraph: "Troféu Ouro e Destaque em Gente/Cultura.",
    Backgroundcolor: "#002364",
  },
  {
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/cart_smart_customer.webp`,
    imageFallback: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/cart_smart_customer.webp`,
    title: "Premio Smart Customer",
    paragraph: "Troféu Ouro com o case: “Expertise 360 e Campanha Ninja”.",
    Backgroundcolor: "#008C84",
  },
  {
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/card_premio_aloic_latam.webp`,
    imageFallback: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/card_premio_aloic_latam.webp`,
    title: "Prêmio Aloic Latam",
    paragraph:
      "Troféu Ouro na categoria “Melhor Estratégia de Atendimento ao Cliente”.",
    Backgroundcolor: "#D70064",
  },
  {
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/card_premio_abrarec.webp`,
    imageFallback: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/card_premio_abrarec.webp`,
    title: "Prêmio Abrarec 2025",
    paragraph: "Reconhecimento na categoria Atendimento geral.",
    Backgroundcolor: "#002364",
  },
  {
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/card_premio_segurador_brasil.webp`,
    imageFallback: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/card_premio_segurador_brasil.webp`,
    title: "Prêmio Segurador Brasil",
    paragraph:
      "Trofèu Ouro na categoria Liderança de Mercado no Segmento Habitacional.",
    Backgroundcolor: "#008C84",
  },
  {
    image: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/card_premio_cliente_sa.webp`,
    imageFallback: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/card_premio_cliente_sa.webp`,
    title: "ClienteSA",
    paragraph: "Troféu e selo digital Ouro na categoria Seguros & Previdência.",
    Backgroundcolor: "#D70064",
  },
];
